var $5b74f075dacedebf$exports = {};
/* =========================================================
   QUEM SOMOS - JS
========================================================= */ document.addEventListener("DOMContentLoaded", ()=>{
    "use strict";
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    /* =====================================================
     MENU MOBILE
  ===================================================== */ const menuBtn = document.getElementById("headerMenuBtn");
    const nav = document.getElementById("headerMainNav");
    if (menuBtn && nav) menuBtn.addEventListener("click", ()=>{
        const isOpen = nav.classList.toggle("is-open");
        menuBtn.classList.toggle("is-active", isOpen);
        menuBtn.setAttribute("aria-expanded", String(isOpen));
        document.body.classList.toggle("menu-open", isOpen);
    });
    /* =====================================================
     DROPDOWN CRGRs
  ===================================================== */ const dropdownToggle = document.getElementById("headerCrgrToggle");
    const submenu = document.getElementById("headerCrgrSubmenu");
    const dropdown = document.getElementById("headerCrgrDropdown");
    if (dropdownToggle && submenu && dropdown) {
        dropdownToggle.addEventListener("click", (event)=>{
            event.preventDefault();
            event.stopPropagation();
            const isOpen = submenu.classList.toggle("is-open");
            dropdown.classList.toggle("is-open", isOpen);
            dropdownToggle.classList.toggle("is-open", isOpen);
            dropdownToggle.setAttribute("aria-expanded", String(isOpen));
        });
        document.addEventListener("click", (event)=>{
            const clickedInside = dropdown.contains(event.target);
            if (!clickedInside) {
                submenu.classList.remove("is-open");
                dropdown.classList.remove("is-open");
                dropdownToggle.classList.remove("is-open");
                dropdownToggle.setAttribute("aria-expanded", "false");
            }
        });
    }
    /* =====================================================
     REVEAL
  ===================================================== */ const revealItems = Array.from(document.querySelectorAll("[data-reveal]"));
    function initReveal() {
        if (!revealItems.length) return;
        if (!("IntersectionObserver" in window) || prefersReducedMotion) {
            revealItems.forEach((item)=>item.classList.add("in"));
            return;
        }
        const observer = new IntersectionObserver((entries, obs)=>{
            entries.forEach((entry)=>{
                if (!entry.isIntersecting) return;
                entry.target.classList.add("in");
                obs.unobserve(entry.target);
            });
        }, {
            threshold: 0.12,
            rootMargin: "0px 0px -8% 0px"
        });
        revealItems.forEach((item)=>observer.observe(item));
    }
    /* =====================================================
     FOCO ACESSÍVEL
  ===================================================== */ function initCardsKeyboardFocus() {
        const cards = document.querySelectorAll(".card, .logo-card, .side-item");
        cards.forEach((card)=>{
            card.addEventListener("focusin", ()=>{
                card.classList.add("is-focused");
            });
            card.addEventListener("focusout", ()=>{
                card.classList.remove("is-focused");
            });
        });
    }
    /* =====================================================
     PARALLAX SUAVE
  ===================================================== */ function initSoftParallax() {
        const sideCard = document.querySelector(".about-side-card");
        if (!sideCard || prefersReducedMotion) return;
        window.addEventListener("scroll", ()=>{
            const rect = sideCard.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            if (rect.top > windowHeight || rect.bottom < 0) return;
            const movement = Math.min(10, Math.max(-10, rect.top * -0.015));
            sideCard.style.transform = `translateY(${movement}px)`;
        }, {
            passive: true
        });
    }
    /* =====================================================
     CURSOR GLOW
  ===================================================== */ function initCursorGlow() {
        const glow = document.getElementById("cursorGlow");
        if (!glow) return;
        document.addEventListener("mousemove", (event)=>{
            glow.style.transform = `translate(${event.clientX}px, ${event.clientY}px)`;
        }, {
            passive: true
        });
    }
    /* =====================================================
     INIT
  ===================================================== */ initReveal();
    initCardsKeyboardFocus();
    initSoftParallax();
    initCursorGlow();
});


//# sourceMappingURL=quem-somos.05ccc058.js.map
